import request from '@/utils/request'

/** 发送消息 */
export function sendNotification(type, title, content, communityId, userIds) {
  return request({
    url: '/manage/notification/send',
    method: 'post',
    data: { type, title, content, communityId, userIds }
  })
}

/** 消息列表 */
export function getNotificationList(page = 1, size = 10) {
  return request({
    url: '/manage/notification/list',
    method: 'get',
    params: { page, size }
  })
}
